<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="4" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="4" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="4" class="pt-[60px] md:pt-0"></app-subheader>

    <div
      class="w-full max-w-[860px] mx-auto px-4 sm:px-6 md:px-8 pb-28 md:pb-16"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);"
    >
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-center">
        Documentación
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-6 text-center">
        Busca y sube tus archivos
      </p>

      <form [formGroup]="documentsForm" (ngSubmit)="onSubmit()">
        <!-- Área de subida principal (Drag & Drop) -->
        <div
          class="rounded-xl bg-indigo-50/70 p-6 md:p-8 shadow-sm flex flex-col items-center mb-5 transition-colors"
          [class.drop-active]="isDragging"
          [class.border-red-300]="selectedTargetKey === 'addressProof' && addressProof?.invalid && addressProof?.touched"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="w-16 h-16 rounded-full bg-white shadow flex items-center justify-center mb-4">
            <i class="pi pi-cloud-upload text-indigo-500 text-2xl"></i>
          </div>
          <p class="text-sm text-gray-600 mb-3 text-center">
            Arrastra y suelta aquí o usa el botón para seleccionar
          </p>
          <p class="text-xs text-gray-500 mb-4">
            Destino: <span class="font-medium">{{ selectedTargetKey === 'addressProof' ? 'Comprobante de domicilio' : 'Comprobante de ingresos' }}</span>
          </p>
          <button
            type="button"
            class="btn-primary w-[160px] h-[50px]"
            (click)="onUploadClick(fileInput)"
          >
            Subir
          </button>
          <input
            #fileInput
            type="file"
            accept="image/*,application/pdf"
            class="hidden"
            (change)="onFileSelected($event)"
          />
          
          <!-- Mensaje de error para el área de subida -->
          <small *ngIf="selectedTargetKey === 'addressProof' && addressProof?.invalid && addressProof?.touched" class="text-red-500 mt-2 text-center">
            {{ getErrorMessage('addressProof') }}
          </small>
        </div>

        <!-- Lista de documentos: clic en la tarjeta selecciona el destino -->
        <div class="space-y-3">
          <!-- Domicilio -->
          <div
            class="doc-card cursor-pointer"
            [class.doc-card-selected]="selectedTargetKey === 'addressProof'"
            [class.border-red-300]="addressProof?.invalid && addressProof?.touched"
            (click)="selectTarget('addressProof')"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <i class="pi pi-user text-indigo-600"></i>
                <span class="font-medium">Comprobante de domicilio</span>
                <span class="text-red-500 text-sm">*</span>
              </div>
              <div class="flex items-center gap-4">
                <i class="pi pi-check-circle text-green-500" *ngIf="files[0].done"></i>
                <button type="button" class="text-gray-600 hover:text-red-500" (click)="removeFile('addressProof', $event)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
            <div class="mt-3">
              <div class="progress-track">
                <div class="progress-bar" [style.width.%]="files[0].progress"></div>
              </div>
            </div>
            <small *ngIf="addressProof?.invalid && addressProof?.touched" class="text-red-500 mt-1 block">
              {{ getErrorMessage('addressProof') }}
            </small>
          </div>

          <!-- Ingresos -->
          <div
            class="doc-card cursor-pointer"
            [class.doc-card-disabled]="files[1].disabled"
            [class.doc-card-selected]="selectedTargetKey === 'incomeProof' && !files[1].disabled"
            [class.border-red-300]="incomeProof?.invalid && incomeProof?.touched"
            (click)="selectTarget('incomeProof')"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <i class="pi pi-users"></i>
                <span class="font-medium">Comprobante de ingresos</span>
                <span class="text-red-500 text-sm">*</span>
              </div>
              <div class="flex items-center gap-4">
                <i class="pi pi-check-circle text-green-500" *ngIf="files[1].done"></i>
                <button type="button" class="text-gray-400" [disabled]="files[1].disabled" (click)="removeFile('incomeProof', $event)">
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            </div>
            <div class="mt-3">
              <div class="progress-track">
                <div class="progress-bar" [style.width.%]="files[1].progress"></div>
              </div>
            </div>
            <small *ngIf="incomeProof?.invalid && incomeProof?.touched" class="text-red-500 mt-1 block">
              {{ getErrorMessage('incomeProof') }}
            </small>
          </div>
        </div>

        <!-- Información adicional -->
        <div class="mt-4 p-3 bg-blue-50 rounded-lg">
          <p class="text-sm text-blue-700">
            <i class="pi pi-info-circle mr-2"></i>
            Formatos aceptados: JPG, PNG, PDF (máximo 5MB)
          </p>
        </div>

        <!-- Botón Continuar -->
        <div class="pt-8 flex justify-center">
          <button
            type="submit"
            class="btn-primary w-full max-w-[300px] h-[46px]"
            [disabled]="!canContinue"
            [class]="
              'btn-primary w-full md:w-[300px] h-[46px]' +
              (!canContinue
                ? ' opacity-50 cursor-not-allowed'
                : '')
            "
          >
            Continuar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
